import { Globals } from "../CoreApp/Globals";

export function appcstr(strCode, replaceDict) {
  return Globals._stringMgr.appcstr(strCode, replaceDict);
}
